module.exports = __webpack_public_path__ + "static/technighter-light-header-3401396cc0b3807116f8bb9b0b2ae044.png";